export async function parseAll(asp_lines) {
  // parse entire recommendation
  let strategies = [],
    non_strategies = [],
    detections = [],
    features = [],
    costs = [],
    cost = 0,
    mark_strategy = [],
    mark_adjunct = [],
    rationale = [],
    rationale_queue = [],
    entire = [];

  for (const line of asp_lines) {
    let parsed = parseLine(line);
    entire.push(parsed);
    switch (parsed.pred) {
      case "do":
        strategies.push(parsed);
        break;
      case "dont":
        non_strategies.push(parsed);
        break;
      case "detect":
        detections.push(parsed);
        break;
      case "big":
        costs.push(parsed);
        break;
      case "small":
        costs.push(parsed);
        break;
      case "strategy":
        mark_strategy.push(parsed);
        break;
      case "adjunct":
        mark_adjunct.push(parsed);
        break;
      case "cost":
        cost = parseInt(parsed.args[0]);
        break;
      case "rationale":
        rationale.push(parseRationale(line));
      case "rationale_queue":
        rationale_queue.push(parsed);
      default:
        features.push(parsed);
        break;
    }
  }

  rationale = rationale.sort((a, b) => a[2] - b[2]);

  return {
    strategies,
    non_strategies,
    detections,
    features,
    costs,
    cost,
    mark_strategy,
    mark_adjunct,
    entire,
    rationale,
    rationale_queue
  };
}

export function parseLine(asp) {
  // parse each asp line
  let parsed = asp.trim().match(/\"[a-zA-Z0-9\-\_^,\s]+\"|[a-zA-Z0-9\-\_]+/gi);
  return { pred: parsed[0], args: parsed.slice(1), asp };
}

function parseRationale(asp) {
  // parse each asp line
  let parsed = asp.trim().match(/\"[^\"]+\"/gi);
  let scores = asp.trim().match(/[0-9]/gi);
  let score = scores[scores.length - 1];
  return [parsed[0].replace(/\"/gi, ''), parsed[1]?.replace(/\"/gi, ''), score];
}